var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.money_format;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
$(document).on('mrkQuickViewLoaded', function(e) {
  initOptions();
});

// ── Filter engraving cards by MOQ ────────────────────────────────
function updateEngraavingCardsByMOQ() {
  var inputQuantity = parseInt($('[name="numofpack"]').val()) || 0;
  
  // If input is 0, show all cards
  if (inputQuantity === 0) {
    $('.wd-engraving-card').show();
    return;
  }
  
  $('.wd-engraving-card').each(function() {
    var moq = parseInt($(this).attr('data-moq')) || 0;
    if (inputQuantity >= moq) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
}

function normalizeQuantity(val, minItem, stepValue) {
  var quantity = parseInt(val, 10);
  if (isNaN(quantity) || quantity < 0) {
    quantity = 0;
  }
  if (quantity > 0 && minItem > 0 && quantity < minItem) {
    quantity = minItem;
  }
  if (quantity > 0 && stepValue > 0 && quantity % stepValue !== 0) {
    quantity = Math.ceil(quantity / stepValue) * stepValue;
  }
  return quantity;
}

function initOptions(){
  var $stepForm = $('.mrk-multi-step-form');
  var stepValue = parseInt($stepForm.attr('data-steps')) || 25;
  var minItem = parseInt($stepForm.attr('data-minimum-item')) || 0;
  var $quantityInput = $('[name="numofpack"]');
  function refreshQuantityMin(quantity) {
    if (minItem > 0 && quantity > 0) {
      $quantityInput.attr('min', minItem);
    } else {
      $quantityInput.removeAttr('min');
    }
  }
  var currentQty = parseInt($quantityInput.val(), 10) || 0;
  refreshQuantityMin(currentQty);
  
  window.totalPrice = parseInt($('.mrk-wrapper .mrk-drop-down-button:eq(0)').attr('finalprice'));
  window.inputQuantity = parseInt($('.mrk-wrapper .mrk-drop-down-button:eq(0)').attr('quantity'));
  $('.mrk-multi-step-form input[type="radio"]').change(function (e) {
    e.preventDefault();
    var $radio = $(this);
    if ($radio.hasClass('wd-engraving-radio')) {
      syncLumSum($radio);
      updateEngravingTooltip($radio);
    }
    manageEventChange();
    updateSummary(window.inputQuantity, window.totalPrice);
  });
  var $checkedOnLoad = $('.wd-engraving-radio:checked');
  if ($checkedOnLoad.length) {
    syncLumSum($checkedOnLoad);
    updateEngravingTooltip($checkedOnLoad);
  }
  // name-engraving radios live outside .mrk-multi-step-form, so bind them explicitly
  $('.mrk-nameeng-option').change(function (e) {
    e.preventDefault();
    manageEventChange();
    updateSummary(window.inputQuantity, window.totalPrice);
  });
  $('.mrk-main-btn').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('mrk-button-active');
    $('.mrk-quantity-price-dropdown-container').slideToggle();
  });
  $('.mrk-drop-down-button:not(.mrk-main-btn)').click(function (e) {
    e.preventDefault();
    var quantity = parseInt($(this).attr('quantity'));
    var buttonHtml = $(this).html();
    var total = parseInt($(this).attr('finalprice'));
    $('.mrk-main-btn').html(buttonHtml).trigger('click');
    $('.mrk-hidden-qty').val(quantity);
    $('[name="numofpack"]').val(quantity);
    refreshQuantityMin(quantity);
    updateSummary(quantity, total);
    updateEngraavingCardsByMOQ();
    $('[name="properties[Size]"]').trigger('change');
    manageEventChange();
  });
  $('.enter_number_of_pack_button').click(function(e) {
      e.preventDefault();
      var inputQuantity = parseInt($('[name="numofpack"]').val());
      inputQuantity = normalizeQuantity(inputQuantity, minItem, stepValue);
      refreshQuantityMin(inputQuantity);
      $('[name="numofpack"]').val(inputQuantity);
      var foundPrice = null;
      var foundQuantity = 0;
      $('.mrk-wrapper .mrk-drop-down-button').each(function() {
          var buttonQuantity = parseInt($(this).attr('quantity'));
          var buttonPrice = parseFloat($(this).attr('price'));
          if (buttonQuantity <= inputQuantity && buttonQuantity > foundQuantity) {
              foundPrice = buttonPrice;
              foundQuantity = buttonQuantity;
          }
      });
      if (foundPrice !== null) {
          var totalPrice = foundPrice * inputQuantity;
          var formattedTotalPrice = Shopify.formatMoney(totalPrice);
          var formattedUnitPrice = Shopify.formatMoney(foundPrice);
          $('.mrk-main-btn .mrk-qty-price-dropdown').html(`${inputQuantity} ${$(this).attr('packs')} x ${formattedUnitPrice}`);
          $('.mrk-main-btn .mrk-dropdown-total').html(formattedTotalPrice);
      }
      updateSummary(inputQuantity, totalPrice);
      $('.mrk-hidden-qty').val(inputQuantity);
      $('.mrk-quantity-price-dropdown-container').slideUp();
      updateEngraavingCardsByMOQ();
      $('[name="properties[Size]"]').trigger('change');
      $('.mrk-main-btn').toggleClass('mrk-button-active');
      manageEventChange();
  });
  $('[name="size-calculator"]').change(function (e) {
    e.preventDefault();
    updateSummary(window.inputQuantity, window.totalPrice);
    var size = $('[name="size-calculator"]:checked').attr('title');
    $(`[name="properties[Size]"][value="${size}"]`).prop('checked', true).trigger('change');
    $('[name="Gravur"]:checked').trigger('change');
  });
  
  // Keep MOQ filtering in sync with manual input and stepper buttons.
  $('[name="numofpack"]').on('change input', function() {
    var inputQuantity = parseInt($(this).val(), 10) || 0;
    inputQuantity = normalizeQuantity(inputQuantity, minItem, stepValue);
    refreshQuantityMin(inputQuantity);
    $(this).val(inputQuantity);
    updateEngraavingCardsByMOQ();
  });
  $('.wd-stepper-minus, .wd-stepper-plus').on('click', function() {
    setTimeout(function() {
      var quantity = parseInt($('[name="numofpack"]').val(), 10) || 0;
      quantity = normalizeQuantity(quantity, minItem, stepValue);
      refreshQuantityMin(quantity);
      $('[name="numofpack"]').val(quantity);
      updateEngraavingCardsByMOQ();
    }, 50);
  });
  
  // Initial visibility state
  updateEngraavingCardsByMOQ();
  
  $('.mrk-get-quote-button').on('click', function() {
      if (!$('.mrk-hidden-qty').val()) {
          alert('Bitte Menge auswählen!');
          return;
      }
      if($('.mrk-options-vertical input[type="radio"]').length && $('.mrk-options-vertical input[type="radio"]:checked').length == 0){
          alert('Please select any engraving Option!');
          return;
      }
      $('body').addClass('mrk-hubspot-show');
  });
  var intervalId = setInterval(checkAndRegisterForTronLogoEvents, 1000);

  function checkAndRegisterForTronLogoEvents() {
    console.log('hello');
    if (typeof window.tronlogo !== 'undefined') {
        window.tronlogo.registerForTronLogoEvents(TronLogoEventHandler);
        clearInterval(intervalId);
    }
  }
}
function downloadPdf(){
  var quoteHtml = $('.mrk-quote-wrapper').html();
  var stylesheetsHtml = $('#mrk-stylesheets').html();
  var newDocumentContent = `
      <div id="content">
          ${stylesheetsHtml}
          ${quoteHtml}
      </div>
  `;
  var printContainer = document.createElement('div');
  printContainer.innerHTML = newDocumentContent;
  document.body.appendChild(printContainer);
  var content = document.getElementById('content');
  var opt = {
      margin: 0.65,
      filename: 'quote.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
  };
  html2pdf().from(content).set(opt).save().then(() => {
      document.body.removeChild(printContainer);
  });
}
function updateSummary(quantity, itemTotal){
  var lumpsum = parseFloat($('#mrk-lumsum').attr('price'));
  var gravurChecked = $('[name="Gravur"]:checked').length > 0;
  var gravurHasLastQuestion = $('[name="Gravur"]:checked').hasClass('wd-show-last-question');
  var nameEngChecked = $('#mrk-nameeng-yes').is(':checked');

  var lumpsumQty = 0;
  if(gravurChecked) lumpsumQty = 1;
  if(gravurChecked && gravurHasLastQuestion && nameEngChecked) lumpsumQty = 2;

  lumpsum = lumpsum * lumpsumQty;

  var engravingPrice = 0;
  var selectedRadio = $('[name="Gravur"]:checked');

  if(selectedRadio.length){
    // first product uses size-calculator price with discount applied
    // second and third products use their own price attribute directly
    // if(selectedRadio.attr('id') === 'mrk-logo-option-1'){
    //   var title = $('[name="size-calculator"]:checked').attr('title');
    //   var discount = calculateDiscount(quantity, title);
    //   engravingPrice = (parseFloat($('[name="size-calculator"]:checked').val()) - discount) * quantity;
    // } else {
    //   var title = $('[name="size-calculator"]:checked').attr('title');
    //   var discount = calculateDiscount(quantity, title);
    //   var radioPrice = parseFloat(selectedRadio.attr('price')) || 0;
    //   engravingPrice = (radioPrice - discount) * quantity;
    // }
    if(selectedRadio.attr('hasvariants') === 'true'){
      // price + discount come from the selected size variant (HD Lasergravur)
      var sizeRadio = $('[name="size-calculator"]:checked');
      var discount = calculateDiscount(quantity, sizeRadio.attr('variantid'));
      engravingPrice = (parseFloat(sizeRadio.val()) - discount) * quantity;
    } else {
      // single-variant options (Aufdruck 1c, UV-Druck 4c): key the discount by
      // the variant id so the "Default Title" collision no longer applies
      var discount = calculateDiscount(quantity, selectedRadio.attr('variantid'));
      var radioPrice = parseFloat(selectedRadio.attr('price')) || 0;
      engravingPrice = (radioPrice - discount) * quantity;
    }
  }

  // name engraving — priced only when "Ja" is selected and the last question is checked
  var nameEngPrice = 0;
  var nameEngYes = $('.mrk-nameeng-option:checked').attr('data-nameeng') === 'yes';
  var nameEngActive = nameEngYes && $('.wd-show-last-question').is(':checked');
  if(nameEngActive){
    var nameEngRadio = $('[data-nameeng="yes"]');
    var nameEngUnit = parseFloat(nameEngRadio.val()) || 0; // value = variant.price (cents)
    var nameEngDiscount = calculateDiscount(quantity, nameEngRadio.attr('variantId'));
    nameEngPrice = (nameEngUnit - nameEngDiscount) * quantity;
  }

  console.log(itemTotal, engravingPrice, lumpsum);
  var engravingTitle = $('.mrk-engraving').val();
  $('.mrk-item-cost').html(Shopify.formatMoney(itemTotal));
  $('.mrk-engraving-cost').html(Shopify.formatMoney(engravingPrice));
  $('.unit-total-price').html(Shopify.formatMoney(itemTotal));
  $('.unit-quantity').html(quantity);
  $('.unit-price-quote').html(Shopify.formatMoney(itemTotal / quantity));
  $('.engraving-quantity').html(quantity);
  $('.engraving-total').html(Shopify.formatMoney(engravingPrice));
  $('.engraving-title').html(engravingTitle);
  $('.lumpsum-quantity').html(lumpsumQty);
  $('.lumpsum-amount').html(Shopify.formatMoney(lumpsum));
  $('.mrk-lumsum-cost').html(Shopify.formatMoney(lumpsum));
  // name engraving rows (on-page summary + quote table) — shown only when active
  $('.mrk-name-engraving-cost').html(Shopify.formatMoney(nameEngPrice));
  $('.name-engraving-quantity').html(quantity);
  $('.name-engraving-total').html(Shopify.formatMoney(nameEngPrice));
  $('.wd-name-engraving-row').toggle(nameEngActive);
  var grandTotal = itemTotal + engravingPrice + nameEngPrice + lumpsum;
  $('.mrk-final-cost').html(Shopify.formatMoney(grandTotal));
  $('.mrk-total-invoice').html(Shopify.formatMoney(grandTotal));
  $('.mrk-price-per-item-cost').html(Shopify.formatMoney(grandTotal / quantity));
  window.totalPrice = itemTotal; window.inputQuantity = quantity;
}
function calculateDiscount(quantity,title) {
  var finalDiscount = 0;
  for (var i = 0; i < window.discounts.length; i++) {
      if (window.discounts[i].title === title) {
          var discountArray = window.discounts[i].discounts;
          for (var j = 0; j < discountArray.length; j++) {
              if (quantity >= discountArray[j].quantity) {
                  finalDiscount = discountArray[j].discount;
              } else {
                  break;
              }
          }
          break;
      }
  }
  return finalDiscount;
}
function syncLumSum($radio) {
  $('#mrk-lumsum')
    .attr('variantid', $radio.data('lumsumVariantid') || '')
    .attr('price', $radio.data('lumsumPrice') || '');
}

function updateEngravingTooltip($radio) {
  if (!$radio || !$radio.length) return;
  var $form = $radio.closest('.mrk-multi-step-form');
  var $tooltip = $form.find('.wd-engraving-printing-options');
  if (!$tooltip.length) return;

  var heading = $radio.data('tooltip-heading') || '';
  var content = $radio.data('tooltip-content') || '';

  $tooltip.find('.wd-tooltip-heading').text(heading);
  $tooltip.find('.wd-tooltip-content').text(content);
}

function manageEventChange(){
  $('.mrk-name-upload').hide();
  var quantity = $('.mrk-hidden-qty').val();
  var parentVariant = $('.mrk-multi-step-form').find('input.mrk-parent-variant').val();
  var properties = '';
  var index = 0;

  // lumpsum — always qty 1 when any radio is selected
  if($('#mrk-lumsum').length){
    var lumsumId = $('#mrk-lumsum').attr('variantid');
    var gravurChecked = $('[name="Gravur"]:checked').length > 0;
    var gravurHasLastQuestion = $('[name="Gravur"]:checked').hasClass('wd-show-last-question');
    var nameEngChecked = $('#mrk-nameeng-yes').is(':checked');

    var lumpsumQty = 0;
    if(gravurChecked) lumpsumQty = 1;
    if(gravurChecked && gravurHasLastQuestion && nameEngChecked) lumpsumQty = 2;
    var singlePropery = `<input type="hidden" name="items[${index}][id]" value="${lumsumId}"/>
    <input type="hidden" name="items[${index}][quantity]" value="${lumpsumQty}"/>
    <input type="hidden" name="items[${index}][properties[_lumsum]]" value="true"/>
    <input type="hidden" class="properParentVariant" name="items[${index}][properties[_parentVariant]]" value="${parentVariant}"/>`;
    index = index + 1;
    properties = properties + singlePropery;
    $('.mrk-name-upload').show();
  }

  var selectedRadio = $('[name="Gravur"]:checked');
  if(selectedRadio.length){
    var selectedVariantId, selectedTitle;
    selectedTitle = selectedRadio.val();

    // first product — variant comes from properties[Size] since it has size variants
    // second and third products — variant comes directly from the radio's variantid
    // if(selectedRadio.attr('id') === 'mrk-logo-option-1'){
    //   selectedVariantId = $('[name="properties[Size]"]:checked').attr('variantid');
    // } else {
    //   selectedVariantId = selectedRadio.attr('variantid');
    // }
    if(selectedRadio.attr('hasvariants') === 'true'){
      selectedVariantId = $('[name="size-calculator"]:checked').attr('variantid');
    } else {
      selectedVariantId = selectedRadio.attr('variantid');
    }

    var singlePropery = `<input type="hidden" name="items[${index}][id]" value="${selectedVariantId}"/>
    <input type="hidden" name="items[${index}][quantity]" value="${quantity}"/>
    <input type="hidden" name="items[${index}][properties[Gravur]]" value="${selectedTitle}"/>
    <input type="hidden" class="properParentVariant" name="items[${index}][properties[_parentVariant]]" value="${parentVariant}"/>`;
    index = index + 1;
    properties = properties + singlePropery;
  }

  // name engraving — add as a separate line item only when "Ja" is selected
  // AND the engraving option that reveals this step ('.wd-show-last-question') is checked.
  // If "Nein" is selected, or the last question is not checked, it is not added.
  var nameEngYes = $('.mrk-nameeng-option:checked').attr('data-nameeng') === 'yes';
  var lastQuestionChecked = $('.wd-show-last-question').is(':checked');
  if(nameEngYes && lastQuestionChecked){
    var nameEngVariantId = $('[data-nameeng="yes"]').attr('variantId');
    var nameEngTitle = $('[data-nameeng="yes"]').attr('title');
    if(nameEngVariantId){
      var singlePropery = `<input type="hidden" name="items[${index}][id]" value="${nameEngVariantId}"/>
      <input type="hidden" name="items[${index}][quantity]" value="${quantity}"/>
      <input type="hidden" name="items[${index}][properties[Namensgravur]]" value="${nameEngTitle}"/>
      <input type="hidden" class="properParentVariant" name="items[${index}][properties[_parentVariant]]" value="${parentVariant}"/>`;
      index = index + 1;
      properties = properties + singlePropery;
    }
  }

  $('.mrk-properties').html(properties);
  var engravings = selectedRadio.length ? selectedRadio.val() : '';
  $('.mrk-engraving').val(engravings);
}
function checkRadioBasedOnSize(cm2,width) {
  let checked = false;
  var orignalChecked = $('[name="properties[Size]"]:checked').val();
  $('[name="properties[Size]"]').each(function() {
      let size = parseInt($(this).attr('size'), 10), variantWidth = parseInt($(this).attr('width'), 10);
      console.log(size, variantWidth, width);
      if(width > variantWidth){
        cm2 = 40;
      }
      if (cm2 <= size) {
          $(this).prop('checked', true);
          checked = true;
          $('[name="properties[Size]"]').trigger('change');
          var checkedVal = $('[name="properties[Size]"]:checked').val();
          $(`[name="size-calculator"][title="${checkedVal}"]`).prop('checked', true).trigger('change');
          if(orignalChecked != checkedVal)
            alert('Aufgrund des Designs ändert sich die Gravurgröße von L auf XL. Eine finale Prüfung erfolgt nach Bestellung.');
          return false;
      }
  });
  if (!checked) {
    $('[name="properties[Size]"]:checked').prop('checked', false);
    alert('Your logo is too big');
  }
}
function TronLogoEventHandler(tronlogoData) {
  if(tronlogoData.type == 'VISUALCREATEDONE'){
    var visualId = tronlogoData.visualId;
    var apiKey = 'YiRhh74ytrIMad7T1q8xS5ziEJsI7HTHhtXefv5G';
    const baseURL = `https://app.promotron.com`,apiKeyURL = `${apiKey}/dtp-resources/${visualId}`;
    const mainURL = `${baseURL}/${apiKeyURL}`;
    const fileUrl = `${baseURL}/api/${apiKeyURL}` + '/visualization';
    $('.mrk-customization-url').val(mainURL);
    const cm2 = (tronlogoData.motiveHeight * tronlogoData.motiveWidth) / 100;
    const width = tronlogoData.motiveWidth;
    $('.mrk-uploader').val(fileUrl);
    $('.productView-image.slick-active img').attr('srcset', fileUrl).css('object-fit', 'contain');
    // $('.mrk-product-image img').attr('src', fileUrl);
    window.tron.Modal.closeModal();
    checkRadioBasedOnSize(cm2,width);
    $('body').addClass('mrk-hubspot-layout-show');
    $('[name="ergebnis_konfigurator"]').val(fileUrl);
    $('.mrk-submit-btn').html(window.variantStrings.addToCart)
  }
}
function checkHashAndRun() {
    if (window.location.hash === '#openSideCart') {
        if (!$('.mrk-cart-drawer').length) {
            $('.header__icon--cart').click();
        }
    }
}
checkHashAndRun();
$(function(){
  if($('.mrk-multi-step-form').length){
    initOptions();
  }
  createHubSpotForms();
})
$(document).on('variantChange', function(e){
  var variant = e.detail.variant;
  $('.mrk-parent-variant').val(variant.id);
  $('.properParentVariant').each(function(){
    $(this).val(variant.id);
  });
  $('.mrk-multi-step-form').find('input.mrk-parent-variant').val(variant.id);
  $('.mrk-get-sample [name="id"]').val(variant.id);
  $('.mrk-product-image img').attr('src', variant.featured_image.src);
})
function createHubSpotForms(){
  hbspt.forms.create({
    region: "eu1",
    portalId: "26144062",
    formId: "07c75804-776b-4c0d-9f61-564363c91f0b",
    target: ".mrk-hub-spot-form-wrapper",
    inlineMessage: "Vielen Dank! Der Download startet in Kürze.",
    onFormReady: function($form) { changehbsptForm($form); },
    onFormSubmitted: function($form, data) { downloadPdf(); }
  });
  hbspt.forms.create({
    region: "eu1",
    portalId: "26144062",
    formId: "84748d7e-af44-48b1-a42d-89aec7aa94e9",
    target: ".mrk-hub-spot-form-wrapper-layout",
      onFormReady: function($form) {
        changehbsptForm($form)
      },
      onFormSubmit: function($form) {
         
      }
  });
  hbspt.forms.create({
    region: "eu1",
    portalId: "26144062",
    formId: "e558b591-0f91-4c40-b2a8-c72bef69329d",
    target: ".mrk-discount-form-wrapper",
      onFormReady: function($form) {
        changehbsptForm($form)
      },
      onFormSubmit: function($form) {
        console.log('[MusterCTA] discount form (e558b591) submitted — letztes_interesse_musterprodukt = "' + $form.find('input[name="letztes_interesse_musterprodukt"]').val() + '"');
      }
  });
  hbspt.forms.create({
    region: "eu1",
    portalId: "26144062",
    formId: "69cc473f-7f9f-4dea-a0f6-10b5e95c8da2",
    inlineMessage: "Vielen Dank! Sie erhalten die PDF-Datei in Kürze.",
    target: ".wd-new-form-wrapper",
      onFormReady: function($form) {
        changehbsptForm($form)
      },
      onFormSubmit: function($form) {
        console.log('[MusterCTA] wd-new form (69cc473f) submitted — letztes_interesse_musterprodukt = "' + $form.find('input[name="letztes_interesse_musterprodukt"]').val() + '"');
      }
  });
}
function changehbsptForm($form){
  $form.find('input:not([type="submit"])').addClass('form-input form-input-placeholder');
  $form.find('input[type="submit"]').addClass('button button--primary');
  $form.find('h1, h2, h3, h4, h5, h6,.hs-main-font-element').addClass('heading text-center');
  setTimeout(function(){
    $('input[name="angefragtes_produkt_design"]').val(window.productTitle || '');
    setMusterprodukt();
  }, 1500);
}
function setMusterprodukt(){
  var value = window.hubspotMusterprodukt || '';
  var $inputs = $('input[name="letztes_interesse_musterprodukt"]');
  if (!$inputs.length) {
    console.warn('[MusterCTA] hidden input "letztes_interesse_musterprodukt" NOT found in any form on this page');
    return;
  }
  if (!value) {
    console.log('[MusterCTA] input found (' + $inputs.length + 'x) but no metafield value on this page — field left empty');
    return;
  }
  $inputs.val(value).trigger('input').trigger('change');
  console.log('[MusterCTA] input found (' + $inputs.length + 'x) — value set to: "' + value + '" | readback: "' + $inputs.first().val() + '"');
}

// body class toggle for first gravur radio
$(document).ready(function () {
  const $radioGroup = $('[name="Gravur"]');

  if (!$radioGroup.length) return;

  function toggleClass() {
    $('body').toggleClass('wd-gravur-checked', $('.wd-show-last-question').is(':checked'));
  }

  toggleClass();

  $radioGroup.on('change', toggleClass);
});
